import { ProductApprovalState } from '@texas/api/endpoints/productApprovalsApi';
import { defaultIconSize, Icons } from '../Icons';
import { ensureEnumNumber } from '@texas/utils/helpers/enumHelpers';
import { Box, BoxProps, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export interface Props extends BoxProps {
  state?: ProductApprovalState;
}
export function PaIcon({ state, ...props }: Props) {
  const { t } = useTranslation();

  if (!state) return null;

  switch (ensureEnumNumber(ProductApprovalState, state)) {
    case ProductApprovalState.Pending:
      return (
        <Tooltip label={t('productApproval.pending')}>
          <Box {...props}>
            <Icons.Eye boxSize={defaultIconSize} />
          </Box>
        </Tooltip>
      );

    case ProductApprovalState.Accepted:
      return (
        <Tooltip label={t('productApproval.accepted')}>
          <Box {...props}>
            <Icons.CheckmarkDecagram boxSize={defaultIconSize} />
          </Box>
        </Tooltip>
      );
    case ProductApprovalState.Rejected:
      return (
        <Tooltip label={t('productApproval.rejected')}>
          <Box {...props}>
            <Icons.Cancel boxSize={defaultIconSize} />
          </Box>
        </Tooltip>
      );
    case ProductApprovalState.Cancelled:
      return (
        <Tooltip label={t('productApproval.cancelled')}>
          <Box {...props}>
            <Icons.MinusCircleOutline boxSize={defaultIconSize} />
          </Box>
        </Tooltip>
      );
    case ProductApprovalState.OnHold:
      return (
        <Tooltip label={t('sample.onHold')}>
          <Box {...props}>
            <Icons.PauseCircle boxSize={defaultIconSize} />
          </Box>
        </Tooltip>
      );
    default:
      return null;
  }
}
